import React from 'react'
import { FixedRadioQuestion, QuestionFrame, BuildingHeightFromFlood } from 'components/questions'


export const Q08 = () => {
  return (
    <QuestionFrame q={8}>

      <BuildingHeightFromFlood />

      <FixedRadioQuestion num={1} content={'受変電設備（特高・高圧・引込開閉器を含む）'} />
      <FixedRadioQuestion num={2} content={'電力会社借室（変電所含む）'} />
      <FixedRadioQuestion num={3} content={'連絡、避難用防災設備（自動火災報知設備、非常放送設備）'} />
      <FixedRadioQuestion num={4} content={'非常用発電機'} />
      <FixedRadioQuestion num={5} content={'消火用防災設備（屋内消火栓・スプリンクラー等の制御盤）'} />
      <FixedRadioQuestion num={6} content={'空調設備（ポンプ、熱交換器含む）'} />
      <FixedRadioQuestion num={7} content={'地域冷暖房供給会社'} />
      <FixedRadioQuestion num={8} content={'給水設備（受水槽、ポンプ）'} />
      <FixedRadioQuestion num={9} content={'ガス設備（マイコンメータ）'} />
      <FixedRadioQuestion num={10} content={'通信設備（MDF）'} />
      <FixedRadioQuestion num={11} content={'エレベータ着床階'} />
      <FixedRadioQuestion num={12} content={'機械式駐車場'} />

    </QuestionFrame>
  )
}
